// A small «Οδηγός» link next to a screen's title that opens the user manual
// at the page explaining that screen. Only for projects behind the meter and
// merchant projects; for every other revenue model it renders nothing, so
// those screens look exactly as before.
import { Link, Tooltip } from "@mui/material";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import { useLanguage } from "../context/LanguageContext";
import { manualLink } from "../utils/manuals";

export default function ManualLink({ settlementType, section, sx }) {
  const { t } = useLanguage();
  const link = manualLink(settlementType, section);
  if (!link) return null;
  const label = t("manualLink.label");
  const tip = t(link.manual === "btm" ? "manualLink.tipBtm" : "manualLink.tipMerchant", { page: link.page - 1 });
  return (
    <Tooltip title={tip}>
      <Link
        href={link.url}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        data-no-translate=""
        data-testid={`manual-link-${section}`}
        aria-label={tip}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          fontSize: "0.8rem",
          fontWeight: 600,
          color: "text.secondary",
          whiteSpace: "nowrap",
          verticalAlign: "middle",
          "&:hover": { color: "primary.main" },
          ...sx,
        }}
      >
        <MenuBookOutlinedIcon sx={{ fontSize: 16 }} />
        {label}
      </Link>
    </Tooltip>
  );
}
